// Global Constants, it removes unnecesary string literals
export default Object.freeze({

    // WEBCHAT STATES
    NOT_STARTED_STATE: 'notstarted',
    STARTED_STATE: 'started',
    WAITING_STATE: 'waiting',
    FINISHED_STATE: 'finished',

    // WEBSOCKET STATES
    WS_CHAT_CREATED: 'chatcreated',
    WS_CONNECTED: 'connected',
    WS_NEW_MESSAGE: 'newmessage',
    WS_CHAT_FINISHED: 'finishchat',
    WS_TYPING: 'typing',
    WS_TIMEOUT: 'timeout',
    WS_TRANSFERRED: 'transferred',
    WS_ATTENDED: 'attended',
    WS_TYPING: 'typing',
    
    //SCREEN SHARING
    WS_REQUEST_SCREEN: 'request_screen',
    WS_SIGNALLING: 'signalling',
    WS_NOT_SUPPORTED: 'not_supported',
    WS_DENIED: 'denied',

    //EVENTS
    WS_WEBCHAT_EVENT: 'webchatevent',
    WS_QUEUE_POSITION: 'queuePosition'
});